/*
 * @Author: Huangxianlong
 * @Date: 2023-10-19 09:27:10
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-11-25 10:25:09
 * @FilePath: \monitor\src\store\modules\test.js
 * @Description: 
 */

import * as api from '../../api';
import { router } from '../../router/index';
import Tools from '../../libs/tools';
const test = {
  state: {
    treeData: [],//side bar tree的数据，缓存以后不需要切换页面不需要更新
    chartData: {},//图表显示的数据
    rCheckedData: [],//图表页面选中项
    oCheckedData: {},//地图页面选中项
    summary: [],//当日的sensor最大值总结
    loadingFlag: false, // loading标志
  },
  getters: {
    treeData: state => state.treeData,
    chartData: state => state.chartData,
    rCheckedData: state => state.rCheckedData,
    summary: state => state.summary,
  },
  mutations: {
    //设置Side bar tree的数据，在选择项目或更换项目时需要调用
    SETTREEDATA(state, data) {
      state.treeData = [];
      state.treeData = data;
    },
    //设置图表的数据，在获取sensor数据后使用
    SETCHARTDATA(state, data) {
      state.chartData = data;
    },
    SETRCHECKEDDATA(state, data) {
      state.rCheckedData = data;
    },
    SETSUMMARY(state, data) {
      state.summary = data;
    },
    SETLOADING(state, data) {
      state.loadingFlag = data;
    }
  },
  actions: {
    //设置Side bar tree的数据，在选择项目或更换项目时需要调用
    setTreeData({ commit }, projectId) {
      let tempData;
      let loginInfo = Tools.methods.StorageGet('loginInfo');
      let adminTag = (loginInfo.userRole === "admin");
      let userId = loginInfo.userId;
      commit("SETLOADING", true);
      api.getTreeData(projectId, adminTag, userId).then(function (response) {
        tempData = response.body.data.children;
        commit("SETTREEDATA", tempData);
        commit("SETLOADING", false);
      }, function (response) {
        console.log("==error==", response);
      })
        .catch(() => {
          commit("SETLOADING", false);
        })

    },
    setChartData({ commit }, data) {
      commit("SETCHARTDATA", data);
    },
    setRCheckedData({ commit }, data) {
      commit("SETRCHECKEDDATA", data);
    },
    setSummary({ commit }, data) {
      commit("SETSUMMARY", data);
    },
  }
};

export default test;



// WEBPACK FOOTER //
// ./src/store/modules/test.js